import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

import { NextPanel } from 'src/app/models/next-panel';
import { CancelEnrollmentRequest, CancelEnrollmentRequestPayload } from 'src/app/models/enrollment-request-cancel';
import { BenefitSummaryList } from 'src/app/models/benefit-summary';
import { EnrollmentBenefitCategory } from '../models/enrollment-category';

const controllerRoute = '/cancel-inet';

@Injectable()
export class EnrollmentCancelService {

    constructor(
        private apiService: ApiService,
    ) {
    }

    public initializeSerivce(): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/initialize`, null).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getCancelRequests(): Observable<CancelEnrollmentRequest> {
        return this.apiService.get(`${controllerRoute}/term-requests`).pipe(
            map((response: CancelEnrollmentRequest) => {
                return response;
            }),
        );
    }

    public submitCancelRequests(payload: CancelEnrollmentRequestPayload): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/term-requests`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getSummary(): Observable<BenefitSummaryList> {
        return this.apiService.get(`${controllerRoute}/summary`).pipe(
            map((response: BenefitSummaryList) => {
                return response;
            }),
        );
    }

    public submitSummary(): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/summary`, null).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getFinalize(): Observable<EnrollmentBenefitCategory> {
        return this.apiService.get(`${controllerRoute}/complete`).pipe(
            map((response: EnrollmentBenefitCategory) => {
                return response;
            }),
        );
    }
}